/*
 * 资产管理接口
 * */
import services from "../config/axios";
import base from "./base";
// 定义参数类型
type paramsType<T> = {
    [key: string]: T;
};

const assetManageAPI = {
    // 获取资产列表
    getAssetList<T>(params: FormData) {
        return services.post(`${base.lk}/Asset/GetAssetList`, params);
    },
    // 获取资产列表
    getAssetListMobile<T>(params: FormData) {
        return services.post(`${base.lkmobile}/Asset/GetAssetList`, params);
    },
    // 获取资产审批
    getAssetAudit<T>(params: FormData) {
        return services.post(`${base.lk}/Asset/GetAssetAudit`, params);
    },
    // 新增资产
    addAsset<T>(params: FormData) {
        return services.post(`${base.lk}/Asset/AddAsset`, params);
    },
    // 更新资产
    updateAsset<T>(params: FormData) {
        return services.post(`${base.lk}/Asset/UpdateAsset`, params);
    },
    // 更新资产创建人
    updateAssetCreator<T>(params: FormData) {
        return services.post(`${base.lk}/Asset/UpdateAssetCreator`, params);
    },
    // 获取一个资产
    getOneAsset<T>(params: FormData) {
        return services.post(`${base.lk}/Asset/GetOneAsset`, params);
    },
    // 获取一个资产View
    getOneAssetView<T>(params: FormData) {
        return services.post(`${base.lk}/Asset/GetOneAssetView`, params);
    },
    // 提交资产
    submitAsset<T>(params: FormData) {
        return services.post(`${base.lk}/Asset/SubmitAsset`, params);
    },
    // 审批资产
    auditAsset<T>(params: FormData) {
        return services.post(`${base.lk}/Asset/AuditAsset`, params);
    },
    // 删除资产
    delAsset<T>(params: FormData) {
        return services.post(`${base.lk}/Asset/DelAsset`, params);
    },
    //更新资产
    refreshAsset<T>(params: FormData) {
        return services.post(`${base.lk}/Asset/RefreshAsset`, params);
    },
    //更新资产
    refreshAssetMobile<T>(params: FormData) {
        return services.post(`${base.lkmobile}/Asset/RefreshAsset`, params);
    },
};

export default assetManageAPI;
